import React, { useState } from 'react';
import T from '../styles/theme';
import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  { auth: { storageKey: 'coreflow-reset' } }
);

export default function ResetPasswordPage() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleReset(e) {
    e.preventDefault();
    setError("");

    if (password.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords don't match");
      return;
    }

    setLoading(true);
    try {
      const { error: updateError } = await supabase.auth.updateUser({ password });
      if (updateError) {
        setError(updateError.message);
      } else {
        setSuccess(true);
        // Redirect to app after 2 seconds
        setTimeout(() => {
          window.history.pushState({}, "", "/dashboard");
          window.location.reload();
        }, 2000);
      }
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  }

  const inputS = {
    width: "100%", padding: "12px 14px", borderRadius: 8,
    border: "1px solid " + T.bdr, background: T.card,
    fontSize: 14, color: T.txt, outline: "none",
    boxSizing: "border-box",
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "transparent",
    }}>
      <div style={{
        width: 400, padding: "40px 36px", borderRadius: 8,
        background: T.card, backdropFilter: "blur(20px) saturate(1.6)", WebkitBackdropFilter: "blur(20px) saturate(1.6)", border: "1.5px solid rgba(217,219,221,0.12)",
        boxShadow: "0 8px 32px rgba(217,219,221,0.12)",
      }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ fontSize: 24, fontWeight: 400, color: T.blue, marginBottom: 4 }}>
            COREFLOW
          </div>
          <div style={{ fontSize: 14, fontWeight: 400, color: T.txt }}>
            Set New Password
          </div>
        </div>

        {success ? (
          <div style={{
            padding: "16px 20px", borderRadius: 8,
            background: T.grn + "10", border: "1px solid " + T.grn + "25",
            textAlign: "center",
          }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>✓</div>
            <div style={{ fontSize: 14, fontWeight: 400, color: T.grn, marginBottom: 4 }}>
              Password Updated
            </div>
            <div style={{ fontSize: 12, color: T.tx2 }}>
              Redirecting you to CoreFlow...
            </div>
          </div>
        ) : (
          <form onSubmit={handleReset}>
            {error && (
              <div style={{
                padding: "10px 14px", borderRadius: 8, marginBottom: 16,
                background: "#E5393510", color: "#E53935", fontSize: 12,
                border: "1px solid #E5393525",
              }}>{error}</div>
            )}

            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 12, fontWeight: 400, color: T.tx2, display: "block", marginBottom: 6 }}>
                New Password
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="At least 8 characters"
                style={inputS}
                autoFocus
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ fontSize: 12, fontWeight: 400, color: T.tx2, display: "block", marginBottom: 6 }}>
                Confirm Password
              </label>
              <input
                type="password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                placeholder="Re-enter password"
                style={inputS}
              />
            </div>

            <button type="submit" disabled={loading} style={{
              width: "100%", padding: "14px", borderRadius: 8, border: "none",
              background: loading ? T.tx3 : T.blue, color: "#fff",
              fontSize: 14, fontWeight: 400, cursor: loading ? "wait" : "pointer",
            }}>
              {loading ? "Updating..." : "Reset Password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
